import { dev as svelteKitDev } from '$app/environment';

export const STRIPE_API_KEY: string =
  (import.meta.env.VITE_STRIPE_API_KEY as string) ?? 'pk_test_Z479gGONFL8EVXUDuMeVbVUc00IaadFnWG';

export const STRIPE_TEST_API_KEY = 'pk_test_Z479gGONFL8EVXUDuMeVbVUc00IaadFnWG';

export const SIFT_ACCOUNT_ID: string =
  (import.meta.env.VITE_SIFT_ACCOUNT_ID as string) ?? '418cc07040';

export const GTAG_ID = (import.meta.env.VITE_GTAG_ID as string) ?? 'G-YQ9MDEKVXG';

export const ENVIRONMENT: string = (import.meta.env?.VITE_ENVIRONMENT as string) ?? 'dev';

export const DEV = svelteKitDev || !!import.meta.env.VITE_PLAYWRIGHT;

export const OPENTELEMETRY_ENABLED: boolean = ENVIRONMENT !== 'dev';

export const APP_NAME =
  ENVIRONMENT === 'production'
    ? 'marketplace-web'
    : ENVIRONMENT === 'next'
      ? 'marketplace-web-next'
      : 'marketplace-web-preview';

export const SENTRY_CONFIG = {
  toucan: {
    dsn: 'https://b39e4f42a9f344ef8fb7773d9009f7ab@o48269.ingest.sentry.io/5893416',
    environment: ENVIRONMENT,
  },
};

export const SIGNER_ENDPOINT: string =
  (import.meta.env?.VITE_SIGNER_ENDPOINT as string) ?? 'https://sign.bitski.com';
